import type { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  description?: string
  right?: ReactNode
}

export function PageHeader({ title, description, right }: PageHeaderProps) {
  return (
    <header className="relative pb-8 mb-8 overflow-hidden">
      {/* Grid texture that fades into the page. Echoes the login wordmark. */}
      <div
        className="absolute inset-0 hawk-grid pointer-events-none"
        aria-hidden
        style={{
          maskImage:
            'linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)',
          WebkitMaskImage:
            'linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)',
        }}
      />
      <div
        className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-border via-border to-transparent"
        aria-hidden
      />

      <div className="relative flex items-end justify-between gap-6 flex-wrap">
        <div className="min-w-0">
          <h1 className="font-display text-[56px] leading-[0.95] tracking-[-0.025em] text-foreground">
            {title}
          </h1>

          {description && (
            <p className="mt-3 text-sm text-muted-foreground max-w-xl leading-relaxed">
              {description}
            </p>
          )}
        </div>
        {right && <div className="flex items-center gap-2 pb-1">{right}</div>}
      </div>
    </header>
  )
}
